module.exports = __webpack_public_path__ + "fonts/footable.2256ee07.ttf";